const isSimuAvailableForContract = (subscription) => (subscription);

export default isSimuAvailableForContract;
